import React, { useState, useEffect } from 'react'
import ContentBox from '../components/ContentBox'
import Header from '../components/home/Header';
import FaqApi from '../services/robinhood/FaqsApi';
import FaqsCategoriasApi from '../services/robinhood/FaqsCatergoriasApi';
import { useLocation } from 'react-router-dom';

export default function FaqsCategoria() {
  const [faqs, setFaqs] = useState([]);
  const location = useLocation();
  const categoria = location.state ? location.state.faqcategoria : { "id": null };

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush';
    new FaqsCategoriasApi().faqs(categoria.id).then(response => {
      setFaqs(response);
    });

  }, [categoria]);

  const FaqsCountComponent = () => {
    return <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12">
      <div className="card" style={{ backgroundColor: '#7F99A6', cursor: 'default' }}>
        <div className="body text-white">
          <h4 style={{ marginBottom: '0px' }}><i className='zmdi zmdi-help-outline' style={{ fontSize: '30px', color: 'lightgreen' }}></i> {faqs.length} {faqs.length > 1 ? 'QUESTÕES' : 'QUESTÃO'}  </h4>
          <span className='m-l-30'>{categoria.categoria.toUpperCase()}</span>
        </div>
      </div>
    </div>
  }

  const CollapseComponent = () => {
    const collapse = [];
    collapse.push(
      faqs.map((faq) => {
        return (
          <div className="panel-group" id={`accordion_${faq.id}`} role="tablist" aria-multiselectable="true">
            <div className="panel panel-col-blue-grey">
              <div className="panel-heading" role="tab" id={`headingOne_${faq.id}`}>
                <h4 className="panel-title rounded"><a role="button" data-toggle="collapse" data-parent={`#accordion_${faq.id}`} href={`#collapseOne_${faq.id}`} aria-expanded="true" aria-controls={`collapseOne_${faq.id}`}> {faq.faq}<i className='zmdi right zmdi-caret-down '></i> </a></h4>
              </div>
              <div id={`collapseOne_${faq.id}`} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={`headingOne_${faq.id}`}>
                <div className="anel-body" dangerouslySetInnerHTML={{ __html: faq.resposta }}></div>
              </div>
            </div>
          </div>
        );
      })
    );
    return collapse;
  };

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '15px', marginBottom: '-30px' }}> <i className='zmdi zmdi-help'></i> FAQ - FREQUENTLY ASKED QUESTIONS  </h5>
      </Header>
      <section className="content">
        <div className='container-fluid"'>
          <div className="row clearfix">
            <FaqsCountComponent />
            <div className="col-lg12 col-md-12 col-sm-12">
              <div className="card">
                <div className="header">
                  <h2> CASO SUA DÚVIDA NAO ESTEJA NA LISTA ENTRE EM CONTATO PELO EMAIL  <small> <i className='zmdi zmdi-email'></i> leirobin@fjp.mg.gov.br  <code></code> </small> </h2>
                </div>
                <div className="body">
                  <div className="row clearfix">
                    <div className="col-md-12 col-lg-12">
                      <CollapseComponent />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}
